import {css} from 'lit';
export const MarkdownSharedStyles = css`p {
    margin: 0 0 1.12em 0;
}

p:last-child {
    margin: 0;
}

code {
    font-family: var(--keli-font-monospace);
    font-size: .9em !important;
    padding: 1px 3px;
    color: var(--keli-text);
    background: var(--keli-subtle-background) !important;
    border-radius: 3px;
    border: 1px solid var(--keli-subtle-border-color);
    white-space: pre-wrap;
}

pre code {
    display: block;
    padding: .5em;
    overflow-x: auto;
}

pre code[class*='-wrap'] {
    white-space: pre-wrap !important;
}

hr {
    height: 0;
    border: 0;
    border-top: 1px solid var(--keli-theme-accent-500);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

blockquote {
    padding: 0 15px;
    margin: 0 0 1em 5px;
    color: var(--keli-text);
    border-left: 4px solid var(--keli-subtle-border-color);
}

img {
    max-width: 100%;
}

table:not(.no-style) {
    margin-bottom: .8em;
    border-collapse: collapse;
}

table:not(.no-style) th:not(:empty) {
    font-weight: bold;
    padding: 4px 8px !important;
    border: 1px solid var(--keli-table-border-color);
    font-size: .9em;
    background-color: var(--keli-table-header-color);
}

table:not(.no-style) th:empty {
    padding: 0 !important;
    border: none !important;
}

table:not(.no-style) td {
    padding: 4px 8px !important;
    border: 1px solid var(--keli-table-border-color);
}

table:not(.no-style) th:not([align]), table:not(.no-style) td:not([align]) {
    text-align: left;
}

.emoji {
    height: 1em;
    width: auto;
    vertical-align: baseline;
}

h1, h2, h3 {
    font-weight: 300;
    margin-bottom: .3em !important;
}

h4, h5, h6 {
    font-weight: 700;
    margin-bottom: .2em !important;
    margin-top: .2em !important;
}

h1 {
    font-size: 1.7em !important;
}

h2 {
    font-size: 1.4em !important;
}

h3 {
    font-size: 1.2em !important;
}

h4 {
    font-size: 1.2em !important;
}

h5 {
    font-size: 1.1em !important;
}

h6 {
    font-size: 1em !important;
}

summary {
    cursor: pointer;
    outline: none;
}`;

import {html} from '@polymer/polymer';
export const MarkdownSharedStylesHTML = html`<style>p {
    margin: 0 0 1.12em 0;
}

p:last-child {
    margin: 0;
}

code {
    font-family: var(--keli-font-monospace);
    font-size: .9em !important;
    padding: 1px 3px;
    color: var(--keli-text);
    background: var(--keli-subtle-background) !important;
    border-radius: 3px;
    border: 1px solid var(--keli-subtle-border-color);
    white-space: pre-wrap;
}

pre code {
    display: block;
    padding: .5em;
    overflow-x: auto;
}

pre code[class*='-wrap'] {
    white-space: pre-wrap !important;
}

hr {
    height: 0;
    border: 0;
    border-top: 1px solid var(--keli-theme-accent-500);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

blockquote {
    padding: 0 15px;
    margin: 0 0 1em 5px;
    color: var(--keli-text);
    border-left: 4px solid var(--keli-subtle-border-color);
}

img {
    max-width: 100%;
}

table:not(.no-style) {
    margin-bottom: .8em;
    border-collapse: collapse;
}

table:not(.no-style) th:not(:empty) {
    font-weight: bold;
    padding: 4px 8px !important;
    border: 1px solid var(--keli-table-border-color);
    font-size: .9em;
    background-color: var(--keli-table-header-color);
}

table:not(.no-style) th:empty {
    padding: 0 !important;
    border: none !important;
}

table:not(.no-style) td {
    padding: 4px 8px !important;
    border: 1px solid var(--keli-table-border-color);
}

table:not(.no-style) th:not([align]), table:not(.no-style) td:not([align]) {
    text-align: left;
}

.emoji {
    height: 1em;
    width: auto;
    vertical-align: baseline;
}

h1, h2, h3 {
    font-weight: 300;
    margin-bottom: .3em !important;
}

h4, h5, h6 {
    font-weight: 700;
    margin-bottom: .2em !important;
    margin-top: .2em !important;
}

h1 {
    font-size: 1.7em !important;
}

h2 {
    font-size: 1.4em !important;
}

h3 {
    font-size: 1.2em !important;
}

h4 {
    font-size: 1.2em !important;
}

h5 {
    font-size: 1.1em !important;
}

h6 {
    font-size: 1em !important;
}

summary {
    cursor: pointer;
    outline: none;
}</style>`;
